// extracted by mini-css-extract-plugin
export default {"container":"CategoryBreadcrumbs_container__U+dfl"};